import React from "react";

function ErrorPage() {
  return <div style={{ color: "#fff" }}>ERROR! PAGE NOT FOUND</div>;
}

export default ErrorPage;
